import { render, staticRenderFns } from "./GroupDashboard.vue?vue&type=template&id=06dd8fb6&"
import script from "./GroupDashboard.vue?vue&type=script&lang=js&"
export * from "./GroupDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GroupDashboard.vue?vue&type=style&index=0&id=06dd8fb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports